import { Component, ChangeDetectionStrategy } from "@angular/core";
import { BaseFieldComponent } from "../base-field/base-field.component";
import { SimpleFieldMetaData } from "../../../../layout-meta-data/simple-field-meta-data";
import { FieldTypes } from "@nts/std/types";

@Component({
    template: '',
    selector: 'nts-external-field',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export abstract class ExternalFieldComponent extends BaseFieldComponent {
  override type = FieldTypes.External;
  abstract get availableExternalFields(): SimpleFieldMetaData[];

  abstract get decodeProperties(): string[];
  abstract get searchProperties(): string[];
  abstract get fieldSeparator(): string;
}
